import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96105322"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "paypal-btn-content flex-end-ter" }
const _hoisted_2 = { class: "paypal-btn" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "submit" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "submit-paypal" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "paypal-btn-loading" }
const _hoisted_6 = { class: "loading-icon" }
const _hoisted_7 = { class: "loading-text" }

import { getClientIdApi, createPaypalRechargeOrderApi, rechargePaypalCaptureApi } from '@/apis/pay'

import { t } from '@/plugins/i18n'
import { ref, watch, toRaw, onMounted } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  activeVip: {
    type: Object,
    default: () => { return {} }
  },
  orderType: {
    type: Number,
    default: 0
  }
},
  emits: ['success'],
  setup(__props, { emit }) {

const props = __props

const loading = ref(false)

const model: any = ref()
const getClientIdFn = () => {
  if (loading.value) return
  loading.value = true
  getClientIdApi().then(res => {
    const clientId = res.data
    const url = 'https://www.paypal.com/sdk/js?client-id=' + clientId + '&vault=true&disable-funding=credit,card'
    loadScript(url, priceChangeButton)
  }).catch(() => {
    const url = 'https://www.paypal.com/sdk/js?client-id=' + 'AbV5vSJuX2yUtfLjQapEOe6Z9fe5XvQub6JURy5PwYsV1r9XYgNHrIMXQgx_Cb0aej5u_ES6AEQ84989' + '&vault=true&disable-funding=credit,card'
    loadScript(url, priceChangeButton)
  })
}
onMounted(() => {
  getClientIdFn()
})
const loadScript = (url: string, callback: () => void) => {
  const script: any = document.createElement('script')
  if (script.readyState) {
    // IE
    script.onreadystatechange = () => {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null
        console.log(t('加载完成！'))
        loading.value = false
        callback()
      }
    }
  } else {
    // 其他浏览器
    script.onload = () => {
      callback()
      console.log(t('加载完成！'))
      loading.value = false
    }
  }
  script.src = url
  document.body.appendChild(script)
}
const priceChangeButton = () => {
  const btn = document.querySelector('.submit-paypal')
  btn && (btn.innerHTML = '')
  const paypal = (window as any).paypal
  let payPalSubscriptionId: string
  paypal.Buttons({
    createSubscription: function () {
      // This function sets up the details of the transaction, including the amount and line item details.
      return createPaypalRechargeOrderApi({
        membershipTemplateId: props.activeVip.membershipTemplateId,
        membershipTemplatePriceId: props.activeVip.membershipTemplatePriceId,
        orderType: props.orderType,
        membershipTrialActivityId: props.activeVip.trialFlag ? props.activeVip.membershipTrialActivityId : undefined,
        membershipTrialActivityComboId: props.activeVip.trialFlag ? props.activeVip.membershipTrialActivityComboId : undefined,
        membershipTemplatePrice: props.activeVip
      }).then(res => {
        payPalSubscriptionId = res.data.payPalSubscriptionId
        return res.data.payPalSubscriptionId
      })
    },
    onApprove: function (data: any, actions: any) {
      console.log(data, actions)
      return rechargePaypalCaptureApi({
        payPalOrderId: data.orderID,
        payPalSubscriptionId
      }).then(() => {
        emit('success')
      })
    }
  }).render('.submit-paypal')
}

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, _hoisted_4, 512), [
      [_vShow, !loading.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("span", _hoisted_6, null, 512), [
        [_directive_loading, true]
      ]),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('PayPal加载中')) + "…", 1)
    ], 512), [
      [_vShow, loading.value]
    ])
  ]))
}
}

})